import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShareOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.743 30.704v10.822L42.268 24 24.743 6.474v9.182C14.718 16.38 6.676 24.263 5.72 34.222a21 21 0 0 0-.095 1.994q.002.593.036 1.176a31 31 0 0 1 2.474-1.785 30.5 30.5 0 0 1 16.556-4.903zM8.516 32.456c1.643-7.782 8.283-13.72 16.407-14.307l2.32-.167V12.51L38.733 24l-11.49 11.49v-7.284l-2.498-.002a33 33 0 0 0-16.23 4.252" })
});
export default SvgShareOutline;
